var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToCminus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.499 0C5.17 0 .012 5.148 0 11.477a11.43 11.43 0 0 0 3.352 8.139A11.43 11.43 0 0 0 11.478 23h.022c6.328 0 11.487-5.149 11.5-11.479C23.012 5.181 17.863.012 11.499 0m6 12.012-12-.012a.5.5 0 0 1 .001-1v-.012l12 .012c.276.012.5.235.5.512-.001.276-.501.5-.501.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToCminus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TOCminus.svg";